/** The server's stage words (`evidence/stages.py`), which are the only words for a document's
 * progress. One home: the upload card and the coverage cell's waiting note both print a stage, and
 * a card that coined its own would be a second definition of "ready". */
export const STAGE_WORDS: Record<string, string> = {
  received: "Received",
  checked: "Checked",
  being_read: "Reading",
  awaiting_review: "Needs review",
  ready: "Ready",
  could_not_be_read: "Could not be read",
  set_aside: "Set aside",
  replaced: "Replaced",
};

export function stageWord(stage: string): string {
  return STAGE_WORDS[stage] ?? stage.replace(/_/g, " ");
}
